import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_BookletContent = _resolveComponent("BookletContent")!
  const _component_ScopeManager = _resolveComponent("ScopeManager")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: "",
    class: "pb-0 mb-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "default_card large mx-0 my-2 pa-2 fill-height sticky-card",
        elevation: "0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "4",
                class: "d-flex justify-start"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_back, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'booklet-templates' })))
                  }),
                  _createVNode(_component_v_text_field_filled, {
                    modelValue: _ctx.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
                    label: "Nom de la plaquette",
                    "hide-details": "",
                    class: "px-1",
                    disabled: _ctx.readOnly,
                    density: "compact",
                    onChange: _ctx.onNameChanged
                  }, null, 8, ["modelValue", "disabled", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "4",
                class: "d-flex align-left justify-start"
              }),
              _createVNode(_component_v_col, {
                cols: "4",
                class: "d-flex justify-end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select_filled, {
                    modelValue: _ctx.bundleType,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bundleType) = $event)),
                    items: _ctx.bundleTypes,
                    "hide-details": "auto",
                    label: "Régime",
                    disabled: _ctx.readOnly || _ctx.idToDuplicate,
                    density: "compact"
                  }, null, 8, ["modelValue", "items", "disabled"]),
                  _createVNode(_component_v_btn, {
                    rounded: "",
                    elevation: "0",
                    class: "ml-2",
                    disabled: _ctx.disabledMutation,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.upsertBookletTemplate()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(!_ctx.idTemplate || _ctx.idToDuplicate ? "Créer" : "Modifier"), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto; margin-top: 1vh')
      }, [
        (_ctx.loaded)
          ? (_openBlock(), _createBlock(_component_BookletContent, {
              bookletTemplateId: _ctx.idTemplate,
              booklet: _ctx.content,
              readonly_: _ctx.readOnly,
              bundleType: _ctx.bundleType,
              onBookletChanged: _ctx.onBookletChanged,
              key: _ctx.idTemplate
            }, null, 8, ["bookletTemplateId", "booklet", "readonly_", "bundleType", "onBookletChanged"]))
          : _createCommentVNode("", true),
        _createVNode(_component_ScopeManager, {
          modelValue: _ctx.scopeSync,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.scopeSync) = $event)),
          id: _ctx.scopeId,
          "onUpdate:id": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.scopeId) = $event)),
          name: _ctx.scopeName,
          "onUpdate:name": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.scopeName) = $event)),
          readonly: _ctx.readOnly
        }, null, 8, ["modelValue", "id", "name", "readonly"])
      ], 4)
    ]),
    _: 1
  }))
}